import { Injectable } from '@angular/core';
import { LoggerService } from '../../telemetry/logger.service';
import { Observable } from 'rxjs';
import { StoredDispatchedServiceSyncData } from 'src/app/driver/storage/models/stored-dispatched-service-sync-data';
import { indexedDb } from 'src/app/dexie/indexed-db-data-store';
import { BaseRepository } from 'src/app/repository/base.repository';

/**
 * Provides access to and management of sync data for dispatched services.
 * Handles storage, retrieval, and updates of sync data in IndexedDB.
 * Manages both sync data records and binary data fragments.
 */
@Injectable({
	providedIn: 'root'
})
export class SyncDataRepository extends BaseRepository<StoredDispatchedServiceSyncData> {

	/**
	 * @constructor
	 *
	 * @param logger The logging service.
	 */
	constructor(
		logger: LoggerService,
	) {
		super(indexedDb.DispatchedServiceSyncData, logger);
	}

	/** @inheritdoc */
	public override Update$(syncData: StoredDispatchedServiceSyncData): Observable<void> {
		throw new Error("Update operation not implemented for sync data repository.");
	}
}
